module.exports = __webpack_public_path__ + "static/media/3.bf7c7fce.png";